import * as fromDatatype from '../datatype-library/index';

export interface bl_pgw_contract_rate_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  payment_channel_hdr_guid: fromDatatype.GuidDataFieldInterface;
  contract_hdr_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeClass;
  charge_rate: fromDatatype.BigIntegerDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  payment_provider_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_pgw_contract_rate_hdr_RowClass implements bl_pgw_contract_rate_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  payment_channel_hdr_guid: fromDatatype.GuidDataFieldInterface;
  contract_hdr_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeClass;
  charge_rate: fromDatatype.BigIntegerDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  payment_provider_code: fromDatatype.VarcharDatatypeInterface;
}
